import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useSelected } from '../company/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useFolderExport = () => {
  const { selectedCompanyId: companyId } = useSelected();
  const { mutate: mutateFolderExport } = useAppMutation([QueryKey.FOLDER_EXPORT, companyId], {
    mutationFn: async ({ folderId }: { folderId: string }) => {
      await ApiService.downloadFile({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'vault', 'folders', folderId, 'export'],
      });
    },
  });

  return { mutateFolderExport };
};
